module.exports = __webpack_public_path__ + "static/img/invite_job_footer_banner_h5.6f64f53.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/inviteJob/invite_job_footer_banner_h5.png
// module id = dQ7E
// module chunks = 34